import { Card, Modal, SpinnerOverlay, Toast } from "@vesatogo/grass-core"
import { useState } from "react"
import toast from "react-hot-toast"
import {
  HistoryColumns,
  TransactionHistory,
} from "~/components/Transaction/TransactionHistory"
import {
  useInvoiceSettlementDetailQuery,
  useNetPayableReceiptDetailQuery,
  useNetPayableTradeDetailQuery,
  useReturnTransactionsMutation,
} from "~/generated/graphql"

const ReturnTransactionsModal = ({
  invoiceId,
  tradeId,
  receiptId,
  isOpen,
  onClose,
}: {
  invoiceId?: any
  tradeId?: any
  receiptId?: any
  isOpen: boolean
  onClose?: (refetch?: boolean) => void
}) => {
  const columns = [
    HistoryColumns.DATE?.accessor,
    HistoryColumns.PAYMENT_OPT?.accessor,
    HistoryColumns.PAYMENT_MODE?.accessor,
    HistoryColumns.TRANSACTION_ID?.accessor,
    HistoryColumns.PARENT_TRANSACTION_ID?.accessor,
    HistoryColumns.RELEASED_AMOUNT?.accessor,
    HistoryColumns.NARRATION?.accessor,
  ]

  const [, cancelInvoice] = useReturnTransactionsMutation()
  const [{ data, fetching }] = useInvoiceSettlementDetailQuery({
    variables: {
      id: invoiceId as any,
    },
    pause: !invoiceId || !!tradeId || !!receiptId,
  })

  const [{ data: tradeData, fetching: tradeFetching }] =
    useNetPayableTradeDetailQuery({
      variables: {
        id: tradeId as any,
      },
      pause: !tradeId || !!invoiceId || !!receiptId,
    })

  const [{ data: receiptData, fetching: receiptFetching }] =
    useNetPayableReceiptDetailQuery({
      variables: {
        id: receiptId as any,
      },
      pause: !receiptId || !!invoiceId || !!tradeId,
    })
  const invoice = data?.invoice_by_pk
  const trade = tradeData?.trade_by_pk
  const receipt = receiptData?.receipt_by_pk

  const onSubmit = async () => {
    if (!selectedTransactions?.length) {
      toast.custom(<Toast title="Please select Transactions" intent="danger" />)
      return
    }
    const { data } = await cancelInvoice({
      transactionIds: selectedTransactions,
    })
    if (data?.cancel_transaction?.success) {
      toast.custom(<Toast title="Transactions returned successfully" />)
    } else {
      toast.custom(
        <Toast title="Failed to return transactions" intent="danger" />
      )
    }
    return onClose?.(true)
  }

  const [selectedTransactions, setSelectedTransactions] = useState<any[]>([])

  const onSelect = (value: any) => {
    setSelectedTransactions([...selectedTransactions, value])
  }
  const onDeselect = (value: any) => {
    setSelectedTransactions(
      selectedTransactions.filter((item: any) => item.id !== value.id)
    )
  }

  return (
    <Modal
      bodyClassName="max-w-7xl overflow-visible"
      isOpen={isOpen}
      onClose={() => onClose?.(false)}
      title={"Return Transactions"}
      primaryActionButtonProps={{
        text: "Return Transactions",
        size: "sm",
        onClick: onSubmit,
      }}
      secondaryActionButtonProps={{
        text: "Cancel",
        variant: "outline",
        size: "sm",
        onClick: () => onClose?.(false),
      }}
    >
      <Card className="!rounded-none p-2 bg-gray-100 text-gray-800 ">
        <SpinnerOverlay show={fetching || tradeFetching || receiptFetching} />
        <TransactionHistory
          columns={columns}
          cols={`!grid-cols-8`}
          transactions={
            invoice?.transactions ||
            trade?.transactions ||
            receipt?.transactions
          }
          selectable={true}
          selectedTransactions={selectedTransactions}
          onSelect={onSelect}
          onDeselect={onDeselect}
        />
      </Card>
    </Modal>
  )
}

export default ReturnTransactionsModal
